export const DEFAULT_USER_SETTINGS = {
  assistant: {
    style:          'coachend',   // sachlich | motivierend | analytisch | coachend | direkt
    responseLength: 'normal',     // kurz | normal | ausführlich
    language:       'de',         // de | en
    greetOnSession: true,
    offerBriefing:  true,
    proactiveAlerts: true,
    onDemandOnly:   false,
  },
  profile: {
    role:       '',   // Position / Rolle (Freitext) — fließt in die KI-Ausrichtung
    about:      '',   // Kurzprofil / Über mich (Freitext)
    goals:      '',   // Persönliche Ziele (Freitext)
    focusAreas: '',   // Aktuelle Schwerpunkte (Freitext)
  },
  voice: {
    inputMode:       'push',    // push | continuous
    pushToTalkKey:   'Space',    // KeyboardEvent.code der Push-to-Talk-Taste (nur bei inputMode 'push')
    micEnabled:      true,
    audioResponses:  true,
    autoRead:        false,
    consentAccepted: false,
    // elevenLabsVoiceId ist admin-kontrolliert (users/{uid}.elevenLabsVoiceId)
  },
  memory: {
    sessionEnabled:      true,
    shortTermEnabled:    true,
    longTermEnabled:     true,
    autoSaveTasks:       true,
    autoSaveDecisions:   true,
    autoSaveRisks:       true,
    autoSaveMeetings:    true,
    autoSaveNotes:       true,
  },
  tasks: {
    defaultView:                  'cockpit', // cockpit | focus | list | eisenhower
    focusLimit:                   5,          // 3 | 5 | 8
    showInfoInFocus:              false,
    showExternalOnlyWithFollowup: true,
    agingEnabled:                 true,
    agingYellow:                  7,
    agingOrange:                  14,
    agingRed:                     21,
    waitingReminderDays:          7,
    autoAskWaiting:               false,
  },
  appearance: {
    theme:          'dark',      // dark | light | system
    accentColor:    'cyan',      // cyan | blue | violet | magenta
    layoutDensity:  'standard',  // compact | standard | large
    coachVisual:    'brain',     // brain | orb | minimal
  },
  notifications: {
    inApp: {
      tasks: true, meetings: true, escalations: true, reminders: true, briefing: true,
    },
    email: {
      briefing: false, reminders: false, approvals: true, weekly: false,
    },
    telegram: {
      enabled: false, briefing: false, escalations: false,
    },
  },
  advanced: {
    debugMode: false,
    labFeaturesEnabled: false, // Feature-Labor: experimentelle Features anzeigen (Opt-in)
  },
};

export function mergeWithDefaults(fromFirestore) {
  if (!fromFirestore) return DEFAULT_USER_SETTINGS;
  const merged = {};
  for (const section of Object.keys(DEFAULT_USER_SETTINGS)) {
    merged[section] = { ...DEFAULT_USER_SETTINGS[section], ...(fromFirestore[section] || {}) };
    // Deep merge for nested objects (notifications.inApp etc.)
    for (const key of Object.keys(DEFAULT_USER_SETTINGS[section])) {
      const defaultVal = DEFAULT_USER_SETTINGS[section][key];
      const storedVal  = fromFirestore[section]?.[key];
      if (defaultVal !== null && typeof defaultVal === 'object' && !Array.isArray(defaultVal)) {
        merged[section][key] = { ...defaultVal, ...(storedVal || {}) };
      }
    }
  }
  return merged;
}
